var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M22 18.8233L15.0708 11.9825L21.9042 5.08083L18.8233 2L11.98 8.93167L5.055 2.09583L2 5.15083L8.93417 12.0175L2.09583 18.945L5.15083 22L12.015 15.0683L18.9192 21.9042L22 18.8233Z"}));
}

Close.defaultProps = {"viewBox":"0 0 24 24","style":{"color":"#878D90"}};

module.exports = Close;

Close.default = Close;
